import { type Module } from "vuex";
import type { AxiosError } from "axios";
import type { DefaultApi, UnresponsiveCandidateLogResponse } from "@/api";
import type { State as RootState } from "@/stores";
export interface State {
  logs: Record<number, UnresponsiveCandidateLogResponse>;
}
export const module: Module<State, RootState> = {
  namespaced: true,
  state: {
    logs: {},
  },
  actions: {
    async getUnresponsiveCandidateLog(
      { commit },
      {
        positionId,
        candidateId,
      }: {
        positionId: number;
        candidateId: number;
      },
    ) {
      try {
        const api: DefaultApi = await this.dispatch("getAuthorizedApi", null, {
          root: true,
        });
        const response = await api.getUnresponsiveCandidateLog(
          positionId,
          candidateId,
        );
        const log = response.data;
        commit("setUnresponsiveCandidateLog", {
          candidateId,
          log,
        });
        return log;
      } catch (err: unknown) {
        const axiosErr = err as AxiosError;
        if (axiosErr.response?.status === 404) {
          return undefined;
        }
        throw err;
      }
    },
  },
  mutations: {
    setUnresponsiveCandidateLog(
      state,
      {
        candidateId,
        log,
      }: {
        candidateId: number;
        log: UnresponsiveCandidateLogResponse;
      },
    ) {
      state.logs = Object.assign({}, state.logs, {
        [candidateId]: log,
      });
    },
  },
};
